import { render, staticRenderFns } from "./qyxjh.vue?vue&type=template&id=32a8db18&scoped=true"
import script from "./qyxjh.vue?vue&type=script&lang=js"
export * from "./qyxjh.vue?vue&type=script&lang=js"
import style0 from "./qyxjh.vue?vue&type=style&index=0&id=32a8db18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a8db18",
  null
  
)

export default component.exports